import { ApiError } from '@/@types/generated'
import { buildPath, Params } from '@/routes'
import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router'
import { CompanyDetailsLayout } from '../components/CompanyDetailsLayout'
import { CompanyProvider } from '../hooks/company-provider'
import { useError } from '@/hooks/useError'

export default function CompanyDetails() {
  // Hooks
  const { businessEntityId } =
    useParams<Params<'/companies/:businessEntityId'>>()
  const navigate = useNavigate()
  const { showError } = useError()

  const handleError = useCallback(
    (error: unknown) => {
      // Show not found error
      if (error instanceof ApiError && error.status === 404) {
        showError('Company not found')
      }

      // Redirect to companies index on any error
      navigate(buildPath('/companies'))
    },
    [navigate, showError]
  )

  return (
    <CompanyProvider id={businessEntityId!} onError={handleError}>
      <CompanyDetailsLayout />
    </CompanyProvider>
  )
}
